export default "__VITE_ASSET__51$ug6kU__"